var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.204,
    height: 20.204,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21303"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10480",
    fill: "none",
    d: "M0 0h20.204v20.204H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21305"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21304"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14055",
    d: "M10.102 1.684a8.418 8.418 0 1 0 8.418 8.418 8.443 8.443 0 0 0-8.418-8.418Zm0 15.153a6.735 6.735 0 1 1 6.735-6.735 6.744 6.744 0 0 1-6.735 6.735Zm.421-10.944H9.261v5.051l4.378 2.694.673-1.094-3.788-2.273Z",
    fill: "#5e708d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcons);
export default __webpack_public_path__ + "static/media/timeIcons.4a91afdee16e89227706a90586267abe.svg";
export { ForwardRef as ReactComponent };